/** @format */

// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
  $(document).ready(function () {
    // Main Nav Dropdown
    $("#primary-nav li").hover(
      function () {
        $(this).addClass("hover");
        $("ul.submenu", this).fadeIn(200);
      },
      function () {
        $(this).removeClass("hover");
        $("ul.submenu", this).fadeOut(200);
      }
    );

    // Map: Return to previous page button. Change body id to match map template's name.
    //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
  });
  $("html,body").on("scroll", function () {
    $(window).resize();
  });

  window.onload = function () {
    /*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

    // scrollDownAction(20, 'scroll');

    var rellax = new Rellax(".rellax");

    scrollW();
    window.addEventListener("scroll", function () {
      scrollW();
    });
  };
})();

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");
        document.getElementById("header").classList.remove("up");
      }
    } else {
      // upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");
      }
    }
  } else {
    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
